module.exports = __webpack_public_path__ + "static/media/warning.d94e19ce.png";